// import { useState, useEffect, useCallback } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { ArrowRight } from "lucide-react";

// import heroWebDev from "../assets/hero-web-dev.jpg";
// import heroMobileDev from "../assets/hero-mobile-dev.jpg";
// import heroEcommerce from "../assets/hero-ecommerce.jpg";
// import heroCloud from "../assets/hero-cloud.jpg";
// import heroErp from "../assets/hero-erp.jpg";
// import heroCrm from "../assets/hero-crm.jpg";

// const slides = [
//   {
//     id: 1,
//     title: "Web Development",
//     subtitle:
//       "Build powerful, scalable web applications that drive business growth and deliver exceptional user experiences.",
//     cta: "Get Started",
//     image: heroWebDev,
//     animation: "fadeUp",
//   },
//   {
//     id: 2,
//     title: "Mobile App Development",
//     subtitle:
//       "Create native and cross-platform mobile solutions that engage users and accelerate your digital presence.",
//     cta: "Talk to Experts",
//     image: heroMobileDev,
//     animation: "slideRight",
//   },
//   {
//     id: 3,
//     title: "E-Commerce Development",
//     subtitle:
//       "Launch high-converting online stores with seamless payment integration and optimized checkout flows.",
//     cta: "Get Started",
//     image: heroEcommerce,
//     animation: "zoomIn",
//   },
//   {
//     id: 4,
//     title: "Cloud Solutions",
//     subtitle:
//       "Migrate, scale, and optimize your infrastructure with enterprise-grade cloud architecture and DevOps.",
//     cta: "Talk to Experts",
//     image: heroCloud,
//     animation: "parallax",
//   },
//   {
//     id: 5,
//     title: "ERP Solutions",
//     subtitle:
//       "Streamline operations with custom enterprise resource planning systems tailored to your business processes.",
//     cta: "Get Started",
//     image: heroErp,
//     animation: "reveal",
//   },
//   {
//     id: 6,
//     title: "CRM Solutions",
//     subtitle:
//       "Transform customer relationships with intelligent CRM platforms that boost sales and retention.",
//     cta: "Talk to Experts",
//     image: heroCrm,
//     animation: "blur",
//   },
// ];

// const textVariants = {
//   fadeUp: {
//     initial: { opacity: 0, y: 50 },
//     animate: { opacity: 1, y: 0 },
//     exit: { opacity: 0, y: -30 },
//   },
//   slideRight: {
//     initial: { opacity: 0, x: -60 },
//     animate: { opacity: 1, x: 0 },
//     exit: { opacity: 0, x: 60 },
//   },
//   zoomIn: {
//     initial: { opacity: 0, scale: 0.9 },
//     animate: { opacity: 1, scale: 1 },
//     exit: { opacity: 0, scale: 1.05 },
//   },
//   parallax: {
//     initial: { opacity: 0, y: 60, scale: 1.03 },
//     animate: { opacity: 1, y: 0, scale: 1 },
//     exit: { opacity: 0, y: -40 },
//   },
//   reveal: {
//     initial: { opacity: 0, clipPath: "inset(0 100% 0 0)" },
//     animate: { opacity: 1, clipPath: "inset(0 0% 0 0)" },
//     exit: { opacity: 0, clipPath: "inset(0 0 0 100%)" },
//   },
//   blur: {
//     initial: { opacity: 0, filter: "blur(12px)" },
//     animate: { opacity: 1, filter: "blur(0px)" },
//     exit: { opacity: 0, filter: "blur(12px)" },
//   },
// };

// const bgVariants = {
//   initial: { scale: 1.05, opacity: 0 },
//   animate: { scale: 1, opacity: 1 },
//   exit: { scale: 1.03, opacity: 0 },
// };

// export default function HeroCarousel() {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isPaused, setIsPaused] = useState(false);

//   const nextSlide = useCallback(() => {
//     setCurrentSlide((p) => (p + 1) % slides.length);
//   }, []);

//   useEffect(() => {
//     if (isPaused) return;
//     const interval = setInterval(nextSlide, 2000);
//     return () => clearInterval(interval);
//   }, [isPaused, nextSlide]);

//   const slide = slides[currentSlide];

//   return (
//     <section
//       className="relative w-full h-[90vh] overflow-hidden"
//       onMouseEnter={() => setIsPaused(true)}
//       onMouseLeave={() => setIsPaused(false)}
//     >
//       {/* Background */}
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={slide.id}
//           className="absolute inset-0"
//           variants={bgVariants}
//           initial="initial"
//           animate="animate"
//           exit="exit"
//         >
//           <div
//             className="absolute inset-0 bg-cover bg-center"
//             style={{ backgroundImage: `url(${slide.image})` }}
//           />
//           <div className="absolute inset-0 bg-black/60" />
//         </motion.div>
//       </AnimatePresence>

//       {/* Content */}
//       <div className="relative z-10 h-full flex items-center px-8 md:px-16">
//         <AnimatePresence mode="wait">
//           <motion.div
//             key={slide.id}
//             className="max-w-2xl text-white"
//             variants={textVariants[slide.animation]}
//             initial="initial"
//             animate="animate"
//             exit="exit"
//           >
//             <h1 className="text-4xl md:text-5xl font-bold mb-4">
//               {slide.title}
//             </h1>
//             <p className="text-base md:text-lg mb-6 text-white/90">
//               {slide.subtitle}
//             </p>

//             <button className="bg-blue-600 hover:bg-blue-700 transition px-6 py-3 rounded-full flex items-center gap-2 text-sm font-semibold">
//               {slide.cta} <ArrowRight size={16} />
//             </button>
//           </motion.div>
//         </AnimatePresence>
//       </div>

//       {/* Dots */}
//       <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-20">
//         {slides.map((_, i) => (
//           <button
//             key={i}
//             onClick={() => setCurrentSlide(i)}
//             className={`w-2.5 h-2.5 rounded-full transition ${
//               i === currentSlide ? "bg-white" : "bg-white/40"
//             }`}
//           />
//         ))}
//       </div>

//       {/* Progress Bar */}
//       <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-white/20">
//         <motion.div
//           key={currentSlide}
//           className="h-full bg-blue-500"
//           initial={{ width: "0%" }}
//           animate={{ width: "100%" }}
//           transition={{ duration: 5, ease: "linear" }}
//         />
//       </div>
//     </section>
//   );
// }


// import { useState, useEffect, useCallback } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { ArrowRight } from "lucide-react";

// import heroWebDev from "../assets/hero-web-dev.jpg";
// import heroMobileDev from "../assets/hero-mobile-dev.jpg";
// import heroEcommerce from "../assets/hero-ecommerce.jpg";
// import heroCloud from "../assets/hero-cloud.jpg";
// import heroErp from "../assets/hero-erp.jpg";
// import heroCrm from "../assets/hero-crm.jpg";

// /* ------------------------------------
//    SLIDES
// ------------------------------------ */
// const slides = [
//   {
//     title: "Web Development",
//     subtitle: "Build powerful web applications that scale with your business.",
//     cta: "Get Started",
//     image: heroWebDev,
//     animation: "fadeUp",
//   },
//   {
//     title: "Mobile App Development",
//     subtitle: "Native and cross-platform apps that users love.",
//     cta: "Talk to Experts",
//     image: heroMobileDev,
//     animation: "slideRight",
//   },
//   {
//     title: "E-Commerce Development",
//     subtitle: "High-converting stores with seamless checkout.",
//     cta: "Get Started",
//     image: heroEcommerce,
//     animation: "zoomIn",
//   },
//   {
//     title: "Cloud Solutions",
//     subtitle: "Scalable, secure, enterprise-grade cloud systems.",
//     cta: "Talk to Experts",
//     image: heroCloud,
//     animation: "parallax",
//   },
//   {
//     title: "ERP Solutions",
//     subtitle: "Streamline enterprise processes with custom ERP.",
//     cta: "Get Started",
//     image: heroErp,
//     animation: "reveal",
//   },
//   {
//     title: "CRM Solutions",
//     subtitle: "Boost customer engagement and sales retention.",
//     cta: "Talk to Experts",
//     image: heroCrm,
//     animation: "blur",
//   },
// ];

// /* ------------------------------------
//    TEXT ANIMATIONS (OLD EFFECTS)
// ------------------------------------ */
// const textVariants = {
//   fadeUp: {
//     initial: { opacity: 0, y: 50 },
//     animate: { opacity: 1, y: 0 },
//     exit: { opacity: 0, y: -30 },
//   },
//   slideRight: {
//     initial: { opacity: 0, x: -60 },
//     animate: { opacity: 1, x: 0 },
//     exit: { opacity: 0, x: 60 },
//   },
//   zoomIn: {
//     initial: { opacity: 0, scale: 0.9 },
//     animate: { opacity: 1, scale: 1 },
//     exit: { opacity: 0, scale: 1.05 },
//   },
//   parallax: {
//     initial: { opacity: 0, y: 60, scale: 1.03 },
//     animate: { opacity: 1, y: 0, scale: 1 },
//     exit: { opacity: 0, y: -40 },
//   },
//   reveal: {
//     initial: { opacity: 0, clipPath: "inset(0 100% 0 0)" },
//     animate: { opacity: 1, clipPath: "inset(0 0% 0 0)" },
//     exit: { opacity: 0, clipPath: "inset(0 0 0 100%)" },
//   },
//   blur: {
//     initial: { opacity: 0, filter: "blur(12px)" },
//     animate: { opacity: 1, filter: "blur(0px)" },
//     exit: { opacity: 0, filter: "blur(12px)" },
//   },
// };

// export default function HeroCarousel() {
//   const [current, setCurrent] = useState(0);
//   const [prev, setPrev] = useState(0);
//   const [paused, setPaused] = useState(false);

//   const nextSlide = useCallback(() => {
//     setPrev(current);
//     setCurrent((current + 1) % slides.length);
//   }, [current]);

//   useEffect(() => {
//     if (paused) return;
//     const timer = setInterval(nextSlide, 5000);
//     return () => clearInterval(timer);
//   }, [paused, nextSlide]);

//   return (
//     <section
//       className="relative h-[90vh] w-full overflow-hidden"
//       onMouseEnter={() => setPaused(true)}
//       onMouseLeave={() => setPaused(false)}
//     >
//       {/* PREVIOUS IMAGE (STATIC – NO UNMOUNT) */}
//       <div
//         className="absolute inset-0 bg-cover bg-center"
//         style={{ backgroundImage: `url(${slides[prev].image})` }}
//       />

//       {/* CURRENT IMAGE (CROSS-FADE) */}
//       <motion.div
//         className="absolute inset-0 bg-cover bg-center"
//         style={{ backgroundImage: `url(${slides[current].image})` }}
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 1.2, ease: "easeInOut" }}
//       />

//       {/* DARK OVERLAY */}
//       <div className="absolute inset-0 bg-black/60" />

//       {/* CONTENT */}
//       <div className="relative z-10 h-full flex items-center px-8 md:px-16">
//         <AnimatePresence mode="wait">
//           <motion.div
//             key={slides[current].title}
//             variants={textVariants[slides[current].animation]}
//             initial="initial"
//             animate="animate"
//             exit="exit"
//             transition={{ duration: 0.7, ease: "easeOut" }}
//             className="max-w-2xl text-white"
//           >
//             <h1 className="text-4xl md:text-5xl font-bold mb-4">
//               {slides[current].title}
//             </h1>

//             <p className="text-lg mb-6 text-white/90">
//               {slides[current].subtitle}
//             </p>

//             <button className="bg-blue-600 hover:bg-blue-700 transition px-6 py-3 rounded-full flex items-center gap-2 text-sm font-semibold">
//               {slides[current].cta} <ArrowRight size={16} />
//             </button>
//           </motion.div>
//         </AnimatePresence>
//       </div>
//     </section>
//   );
// }


import { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import heroWebDev from "../assets/hero-web-dev.jpg";
import heroMobileDev from "../assets/hero-mobile-dev.jpg";
import heroEcommerce from "../assets/hero-ecommerce.jpg";
import heroCloud from "../assets/hero-cloud.jpg";
import heroErp from "../assets/hero-erp.jpg";
import heroCrm from "../assets/hero-crm.jpg";

/* ------------------------------------
   SLIDES WITH ROUTES
------------------------------------ */
const slides = [
  {
    title: "Web Development",
    subtitle: "Build powerful web applications that scale with your business.",
    cta: "Get Started",
    image: heroWebDev,
    animation: "fadeUp",
    path: "/services/web",
  },
  {
    title: "Mobile App Development",
    subtitle: "Native and cross-platform apps that users love.",
    cta: "Talk to Experts",
    image: heroMobileDev,
    animation: "slideRight",
    path: "/services/mobile",
  },
  {
    title: "E-Commerce Development",
    subtitle: "High-converting stores with seamless checkout.",
    cta: "Get Started",
    image: heroEcommerce,
    animation: "zoomIn",
    path: "/services/ecommerce",
  },
  {
    title: "Cloud Solutions",
    subtitle: "Scalable, secure, enterprise-grade cloud systems.",
    cta: "Talk to Experts",
    image: heroCloud,
    animation: "parallax",
    path: "/services/cloud",
  },
  {
    title: "ERP Solutions",
    subtitle: "Streamline enterprise processes with custom ERP.",
    cta: "Get Started",
    image: heroErp,
    animation: "reveal",
    path: "/Erp",
  },
  {
    title: "CRM Solutions",
    subtitle: "Boost customer engagement and sales retention.",
    cta: "Talk to Experts",
    image: heroCrm,
    animation: "blur",
    path: "/Crm",
  },
];

/* ------------------------------------
   TEXT ANIMATIONS
------------------------------------ */
const textVariants = {
  fadeUp: {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -30 },
  },
  slideRight: {
    initial: { opacity: 0, x: -60 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 60 },
  },
  zoomIn: {
    initial: { opacity: 0, scale: 0.9 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 1.05 },
  },
  parallax: {
    initial: { opacity: 0, y: 60, scale: 1.03 },
    animate: { opacity: 1, y: 0, scale: 1 },
    exit: { opacity: 0, y: -40 },
  },
  reveal: {
    initial: { opacity: 0, clipPath: "inset(0 100% 0 0)" },
    animate: { opacity: 1, clipPath: "inset(0 0% 0 0)" },
    exit: { opacity: 0, clipPath: "inset(0 0 0 100%)" },
  },
  blur: {
    initial: { opacity: 0, filter: "blur(12px)" },
    animate: { opacity: 1, filter: "blur(0px)" },
    exit: { opacity: 0, filter: "blur(12px)" },
  },
};

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(0);
  const [paused, setPaused] = useState(false);

  const nextSlide = useCallback(() => {
    setPrev(current);
    setCurrent((current + 1) % slides.length);
  }, [current]);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [paused, nextSlide]);

  return (
    <section
      className="relative h-[90vh] w-full overflow-hidden"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* PREVIOUS IMAGE */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${slides[prev].image})` }}
      />

      {/* CURRENT IMAGE */}
      <motion.div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${slides[current].image})` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      />

      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-black/60" />

      {/* CONTENT */}
      <div className="relative z-10 h-full flex items-center px-8 md:px-16">
        <AnimatePresence mode="wait">
          <motion.div
            key={slides[current].title}
            variants={textVariants[slides[current].animation]}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="max-w-2xl text-white"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              {slides[current].title}
            </h1>

            <p className="text-lg mb-6 text-white/90">
              {slides[current].subtitle}
            </p>

            {/* ✅ BUTTON LINK */}
            <Link
              to={slides[current].path}
              className="bg-blue-600 hover:bg-blue-700 transition px-6 py-3 rounded-full flex items-center gap-2 text-sm font-semibold w-fit"
            >
              {slides[current].cta} <ArrowRight size={16} />
            </Link>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
}
